import React from "react";
import ProductCard from "../ProductCard/ProductCard";
import "./ProductGrid.scss";

/**
 *
 * @param {Object} props
 * @param {any[]} [props.items]
 * @param {number} [props.maxItems] - caps how many items render; omit for no cap
 * @param {(item: any, index: number) => Object} props.getCardProps
 * @param {(item: any, index: number) => string} [props.getKey]
 * @param {(item: any) => void} [props.onItemClick]
 * @param {(item: any) => void} [props.onItemPurchase]
 */
const ProductGrid = ({
  items = [],
  maxItems,
  getCardProps,
  getKey,
  onItemClick,
  onItemPurchase,
}) => {
  if (!items.length) return null;

  const visibleItems =
    typeof maxItems === "number" ? items.slice(0, maxItems) : items;

  return (
    <div className="ProductGrid">
      <div className="ProductGrid-list">
        {visibleItems.map((item, index) => {
          const cardProps = getCardProps(item, index);
          const key = getKey ? getKey(item, index) : cardProps.name + index;

          return (
            <ProductCard
              key={key}
              {...cardProps}
              onCardClick={() => onItemClick && onItemClick(item)}
              onCtaClick={() => onItemPurchase && onItemPurchase(item)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductGrid;
